import React, { createContext, useContext, useState } from 'react';
import {
  DEMO_CAPITAL_CALL,
  COMPETING_CALLS,
  DEMO_COUNTERPARTIES,
  COUNTRY_RATINGS,
  DEMO_BANK_RATINGS,
  DEMO_FX_QUOTES,
  DEMO_FX_REQUEST,
  DEMO_INSTRUMENTS,
  FINANCIAL_MODEL,
} from '../data/demoMockData';

const STORAGE_KEY_CALL_ID = 'ff_demo_data_v1_callId';
const STORAGE_KEY_FX_ID = 'ff_demo_data_v1_fxId';
const STORAGE_KEY_SUB_ID = 'ff_demo_data_v1_subId';

const DemoDataContext = createContext(null);

export const DemoDataProvider = ({ children }) => {
  const [capitalCallId, setCapitalCallId] = useState(
    () => localStorage.getItem(STORAGE_KEY_CALL_ID) || DEMO_CAPITAL_CALL.id
  );
  const [fxRequestId, setFxRequestId] = useState(
    () => localStorage.getItem(STORAGE_KEY_FX_ID) || DEMO_FX_REQUEST.id
  );
  const [subscriptionId, setSubscriptionId] = useState(
    () => localStorage.getItem(STORAGE_KEY_SUB_ID) || null
  );

  const updateCapitalCallId = (id) => {
    localStorage.setItem(STORAGE_KEY_CALL_ID, id);
    setCapitalCallId(id);
  };

  const updateFxRequestId = (id) => {
    localStorage.setItem(STORAGE_KEY_FX_ID, id);
    setFxRequestId(id);
  };

  const updateSubscriptionId = (id) => {
    localStorage.setItem(STORAGE_KEY_SUB_ID, id);
    setSubscriptionId(id);
  };

  // Capital calls — primary NCBA Bank Kenya call with current ID + 2 competing calls
  const capitalCalls = [
    { ...DEMO_CAPITAL_CALL, id: capitalCallId },
    ...COMPETING_CALLS,
  ];

  // Foreign exchange data with current request ID
  const fxRequest = { ...DEMO_FX_REQUEST, id: fxRequestId };
  const fxQuotes = DEMO_FX_QUOTES;

  return (
    <DemoDataContext.Provider
      value={{
        // Capital calls
        capitalCalls,
        capitalCallId,
        updateCapitalCallId,

        // Foreign exchange
        fxRequest,
        fxQuotes,
        fxRequestId,
        updateFxRequestId,

        // Subscription
        subscriptionId,
        updateSubscriptionId,

        // Credit scoring
        counterparties: DEMO_COUNTERPARTIES,
        countryRatings: COUNTRY_RATINGS,
        bankRatings: DEMO_BANK_RATINGS,

        // Instruments
        instruments: DEMO_INSTRUMENTS,

        // Financial model
        financialModel: FINANCIAL_MODEL,
      }}
    >
      {children}
    </DemoDataContext.Provider>
  );
};

export const useDemoData = () => {
  const ctx = useContext(DemoDataContext);
  if (!ctx) {
    // Return safe defaults when used outside provider
    return {
      capitalCalls: [],
      capitalCallId: null,
      updateCapitalCallId: () => {},
      fxRequest: null,
      fxQuotes: [],
      fxRequestId: null,
      updateFxRequestId: () => {},
      subscriptionId: null,
      updateSubscriptionId: () => {},
      counterparties: [],
      countryRatings: [],
      bankRatings: [],
      instruments: [],
      financialModel: {},
    };
  }
  return ctx;
};

export default DemoDataContext;
